import {
    ContextMenu,
    AutoColumnSize,
    ManualColumnResize,
    ManualRowResize,
    ManualColumnMove,
    ManualRowMove,
    Formulas,
    CustomBorders,
    UndoRedo,
    Autofill,
    MultipleSelectionHandles,
    registerPlugin,
} from 'handsontable/plugins';
import { registerEditor } from 'handsontable/editors';

// Milanote plugins
import MilanoteCellEditor from './modules/MilanoteCellEditor';
import MilanoteFormulaCellReferencePlugin from './modules/MilanoteFormulaCellReferencePlugin';
import MilanoteFormulaAutocompletePlugin from './modules/MilanoteFormulaAutocompletePlugin';
import MilanoteEditingPlugin from './modules/MilanoteEditingPlugin';
import MilanoteEditingCleanupPlugin from './modules/MilanoteEditingCleanupPlugin';
import MilanoteContextMenuPlugin from './modules/MilanoteContextMenuPlugin';
import MilanoteCopyPastePlugin from './modules/MilanoteCopyPastePlugin';

// Milanote legacy plugins
import LegacyMilanoteCellEditor from './legacy/modules/MilanoteCellEditor';
import LegacyMilanoteFormulaCellReferencePlugin from './legacy/modules/MilanoteFormulaCellReferencePlugin';
import LegacyMilanoteFormulaAutocompletePlugin from './legacy/modules/MilanoteFormulaAutocompletePlugin';
import LegacyMilanoteEditingPlugin from './legacy/modules/MilanoteEditingPlugin';
import LegacyMilanoteEditingCleanupPlugin from './legacy/modules/MilanoteEditingCleanupPlugin';
import LegacyMilanoteContextMenuPlugin from './legacy/modules/MilanoteContextMenuPlugin';

export const registerHotPlugins = () => {
    // Register Handonstable plugins
    registerPlugin(ContextMenu);
    registerPlugin(AutoColumnSize);
    registerPlugin(ManualColumnResize);
    registerPlugin(ManualRowResize);
    registerPlugin(ManualColumnMove);
    registerPlugin(ManualRowMove);
    registerPlugin(Formulas);
    registerPlugin(CustomBorders);
    registerPlugin(UndoRedo);
    registerPlugin(Autofill);
    registerPlugin(MultipleSelectionHandles);

    // Register Hansontable custom plugins
    registerPlugin(MilanoteFormulaCellReferencePlugin);
    registerPlugin(MilanoteFormulaAutocompletePlugin);
    registerPlugin(MilanoteEditingPlugin);
    registerPlugin(MilanoteEditingCleanupPlugin);
    registerPlugin(MilanoteContextMenuPlugin);

    // Register Hansontable custom editor
    registerEditor('milanoteCellEditor', MilanoteCellEditor);

    // --------- Shared Plugins ---------
    registerPlugin(MilanoteCopyPastePlugin);

    // --------- Legacy Plugins ---------

    registerPlugin(LegacyMilanoteFormulaCellReferencePlugin);
    registerPlugin(LegacyMilanoteFormulaAutocompletePlugin);
    registerPlugin(LegacyMilanoteEditingPlugin);
    registerPlugin(LegacyMilanoteEditingCleanupPlugin);
    registerPlugin(LegacyMilanoteContextMenuPlugin);

    // Register legacy Hansontable custom editor
    registerEditor('milanoteCellEditorLegacy', LegacyMilanoteCellEditor);
};
